import { Controller } from "@hotwired/stimulus"

const ACTIVE_TAB_CLASS = "px-3 py-1.5 text-xs font-medium rounded-md transition bg-blue-500 text-white"
const INACTIVE_TAB_CLASS = "setup-tab-inactive px-3 py-1.5 text-xs font-medium rounded-md transition bg-white/[0.05] text-slate-400 hover:bg-white/[0.1]"

export default class extends Controller {
  static targets = ["tabMac", "tabWin", "installCmd", "copyBtnText"]
  static values = {
    baseUrl: String,
    selectedOs: { type: String, default: "mac" }
  }

  selectedOsValueChanged() {
    this._render()
  }

  select(event) {
    this.selectedOsValue = event.params.os
  }

  copy() {
    navigator.clipboard.writeText(this._command()).then(() => {
      if (!this.hasCopyBtnTextTarget) return
      const target = this.copyBtnTextTarget
      target.textContent = "Copied! Paste in terminal"
      clearTimeout(this._copyTimer)
      this._copyTimer = setTimeout(() => { target.textContent = "Copy Command" }, 3000)
    })
  }

  disconnect() {
    clearTimeout(this._copyTimer)
  }

  _command() {
    const url = this.baseUrlValue
    return this.selectedOsValue === "mac"
      ? `curl -fsSL ${url} | bash`
      : `irm "${url}?format=ps1" | iex`
  }

  _render() {
    const os = this.selectedOsValue
    if (this.hasTabMacTarget) {
      this.tabMacTarget.className = os === "mac" ? ACTIVE_TAB_CLASS : INACTIVE_TAB_CLASS
    }
    if (this.hasTabWinTarget) {
      this.tabWinTarget.className = os === "win" ? ACTIVE_TAB_CLASS : INACTIVE_TAB_CLASS
    }
    if (this.hasInstallCmdTarget) {
      this.installCmdTarget.textContent = this._command()
    }
  }
}
